/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventvisibilitypublic2Inputs */

const en_eventvisibilitypublic2 = /** @type {(inputs: Eventvisibilitypublic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const de_eventvisibilitypublic2 = /** @type {(inputs: Eventvisibilitypublic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffentlich`)
};

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Eventvisibilitypublic2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventvisibilitypublic2 = /** @type {((inputs?: Eventvisibilitypublic2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventvisibilitypublic2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventvisibilitypublic2(inputs)
	return de_eventvisibilitypublic2(inputs)
});
export { eventvisibilitypublic2 as "eventVisibilityPublic" }